var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.campaigns && _vm.campaigns.length)?_c('div',{staticClass:"ad html-ad",class:_vm.single.css_class,domProps:{"innerHTML":_vm._s(_vm.convertHTML(_vm.single.html))}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }